import React, { useEffect, useRef,useState } from "react";
import { useTranslation } from "react-i18next";
import { lang } from "../lang";
const AddDropdownPopup = (props) => {
  const [ln, setLn] = useState('en')
  const setPopupClose = props?.setPopupClose


const {t} = useTranslation();
  const ref = useRef(null);
  useOutsideAlerter(ref);

  function useOutsideAlerter(ref) {
    useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          // props?.closeModalWrtOutsideClick();
          setPopupClose && setPopupClose(false)
        }
      }

      document.addEventListener("mousedown", handleClickOutside);

      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  }
  return (
    <div className="blur-screen-full-area inner-modal flex-center">
      <div className="form-container company-form my-3" ref={ref}>
        <h3 className="skill-heading text-center mb-3">{props?.title}</h3>
        <input
          required=""
          type="text"
          placeholder={props?.placeholder}
          class="input-text w-100 mb-2"
          value={props?.inputValue}
          onChange={props?.handleChange}
        />
        <div className=" flex-center">
          <button
            type="submit"
            onClick={props?.hanleClick}
            class="theme-btn px-5 text-center w-75"
            style={{  }}
          >
            {props?.btns}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddDropdownPopup;
